import { UseMutateFunction } from '@taxdown/zeno-sama-query';
import { history } from 'Store';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { routes } from 'Constants/routes';
import { FRONT_PLANS } from 'Constants/plans';
import { ResponseType, ResultType } from 'Types/common';

interface HandleClickParams {
  isActive: boolean;
  data?: ResultType;
  mutate: UseMutateFunction<
    ResponseType<unknown>,
    unknown,
    { taxYear: string; type: string },
    unknown
  >;
  autoRenewal: (params: { isAutoRenewalEnabled: boolean }) => void;
  submitDeclaration: (params: Record<string, never>) => void;
  taxYear: string;
  compensation?: boolean;
  submitInfo?: UseMutateFunction<unknown, unknown, unknown, unknown>;
  notIsPayLater?: boolean;
  isForCompensation?: boolean;
}

const TRIAL_PLAN = 'trial';

export const handleYearsBannerClick = ({
  isActive,
  data,
  mutate,
  autoRenewal,
  submitDeclaration,
  taxYear,
  compensation,
  submitInfo,
  notIsPayLater,
  isForCompensation,
}: HandleClickParams): void => {
  const userIsZeroTaxReturn = data && data?.taxReturnType === TaxReturnTypes.EQUAL;

  const handleActiveSubscription = (): void => {
    mutate(
      {
        taxYear: taxYear.toString(),
        type: TRIAL_PLAN,
      },
      {
        onSuccess: () => {
          const successUrl = `${routes.CHECKOUT_SUCCESS_STEP}?filing=true&plans=${FRONT_PLANS.FLEX_LITE}`;
          if (userIsZeroTaxReturn) {
            history.push(routes.PREVIOUS_YEARS_FILTER, {
              taxReturnType: data?.taxReturnType,
              taxReturnResult: data?.taxReturnResult,
              compensation,
            });
          } else if (
            (!data?.mandatory && data?.taxReturnType !== TaxReturnTypes.TO_RETURN) ||
            isForCompensation
          ) {
            const route = notIsPayLater ? routes.PREVIOUS_YEARS : routes.PREVIOUS_YEARS_FILTER;
            history.push(route, {
              isPrefilingUser: true,
            });
          } else {
            history.push(successUrl, {
              taxReturnType: data?.taxReturnType,
              taxReturnResult: data?.taxReturnResult,
            });
          }
        },
      }
    );
    autoRenewal({ isAutoRenewalEnabled: true });
  };
  if (compensation && submitInfo && isActive) {
    submitInfo({ payWithExternalService: true }, { onSuccess: () => submitDeclaration({}) });
  }
  const shouldSubmitDeclaration = data?.mandatory && userIsZeroTaxReturn && !isForCompensation;

  if (isActive) {
    handleActiveSubscription();
    if (shouldSubmitDeclaration) {
      submitDeclaration({});
    }
  } else if (notIsPayLater) {
    history.push(routes.PREVIOUS_YEARS, {
      isPrefilingUser: true,
    });
  } else {
    history.push(routes.PREVIOUS_YEARS_FILTER);
  }
};
